module.exports = __webpack_public_path__ + "img/barcelo-pool.78625ca5.jpg";